<!--
    @修改人：黎柏祺
    @修改时间：2018-11-28
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @负责人: 谢汉
    @创建时间: 2018-01-18
    @版本:v1.0.12
    @描述: 系统运行质量页
    -->
<template>
  <div class="systemQuality__content">
    <div class="systemQuality__minWidth">
      <div class="systemQuality__form">
        <el-form ref="form" :model="form" :inline="true" input-width="auto">
          <el-form-item :label="$t('systemQuality.time')">
            <el-date-picker
              v-model="form.startTime"
              type="date"
              value-format="timestamp">
            </el-date-picker>
            {{$t('common.to')}}
            <el-date-picker
              v-model="form.endTime"
              type="date"
              value-format="timestamp">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search" v-g-rac="gRac('systemDiagram_search')">{{ $t('common.search') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="systemQuality__tab">
        <el-tabs type="border-card"  v-model="tabName" @tab-click="tabClick">
          <el-tab-pane :label="$t('systemQuality.accidentCount')" :name="$t('systemQuality.accidentCount')">
            <div class="styleControl">
              <describe-block :list="accList"></describe-block>
              <div class="systemQuality__chart">
                <div class="systemQuality__chartTitle">
                  <div class="systemQuality__chartTitle-block"></div>
                  <div v-text="$t('systemQuality.accidentDiagram')"></div>
                </div>
                <chart-base
                v-if="showAcd" 
                ref="accTrend" 
                chart-id="accTrend" 
                :chart-data="accTrendData" 
                :chart-style= "areaStyleA"
                type="AREA">
                </chart-base>
              </div>
              <div class="systemQuality__chart systemQuality__chart-pie">
                <div class="systemQuality__chart-pieBlock">
                  <div class="systemQuality__chartTitle">
                    <div class="systemQuality__chartTitle-block"></div>
                    <div v-text="$t('systemQuality.accidentModule')"></div>
                  </div>
                  <chart-base 
                  v-if="showAcd" 
                  ref="accModulePie" 
                  chart-id="accModulePie" 
                  :chart-data="moduleChartData" 
                  :chart-style="pieStyleA"
                  type="PIE">
                  </chart-base>
                </div>
                <div class="systemQuality__chart systemQuality__chart-pieBlock">
                  <div class="systemQuality__chartTitle">
                    <div class="systemQuality__chartTitle-block"></div>
                    <div v-text="$t('systemQuality.accidentReason')"></div>
                  </div>
                  <chart-base
                  v-if="showAcd"  
                  ref="accReasonPie" 
                  chart-id="accReasonPie" 
                  :chart-data="reasonChartData"
                  :chart-style="pieStyleB" 
                  type="PIE">
                  </chart-base>
                </div>      
              </div>
              <div class="systemQuality__chart">
                <div class="systemQuality__chartTitle">
                  <div class="systemQuality__chartTitle-block"></div>
                  <div v-text="$t('systemQuality.accidentWeekCount')"></div>
                </div>
                <chart-base 
                v-if="showAcd"  
                ref="weekAcc" 
                chart-id="weekAcc" 
                :chart-data="weekAccData" 
                :chart-style="barStyleA"
                type="BAR">
                </chart-base>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('systemQuality.versionCount')" :name="$t('systemQuality.versionCount')">
            <div class="styleControl">
              <describe-block :list="verList"></describe-block>
              <div class="systemQuality__chart">
                <div class="systemQuality__chartTitle">
                  <div class="systemQuality__chartTitle-block"></div>
                  <div v-text="$t('systemQuality.versionDiagram')"></div>
                </div>
                <chart-base 
                v-if="showVer"
                ref="verTrend" 
                chart-id="verTrend" 
                :chart-data="verTrendData" 
                :chart-style= "areaStyleB"
                type="AREA"></chart-base>
              </div>
              <div class="systemQuality__chart systemQuality__chart-pie">
                <div class="systemQuality__chart-pieBlock">
                  <div class="systemQuality__chartTitle">
                    <div class="systemQuality__chartTitle-block"></div>
                    <div v-text="$t('systemQuality.regularVersion')"></div>
                  </div>
                  <chart-base 
                  v-if="showVer"
                  ref="regularVersionPie" 
                  chart-id="regularVersionPie" 
                  :chart-data="regularChartData"
                  :chart-style="pieStyleC" 
                  type="PIE">
                  </chart-base>
                </div>
                <div class="systemQuality__chart systemQuality__chart-pieBlock">
                  <div class="systemQuality__chartTitle">
                    <div class="systemQuality__chartTitle-block"></div>
                    <div v-text="$t('systemQuality.patchVersion')"></div>
                  </div>
                  <chart-base
                  v-if="showVer" 
                  ref="patchVersionPie" 
                  chart-id="patchVersionPie" 
                  :chart-data="patchChartData" 
                  :chart-style="pieStyleD"
                  type="PIE">
                  </chart-base>
                </div>      
              </div>
              <div class="systemQuality__chart">
                <div class="systemQuality__chartTitle">
                  <div class="systemQuality__chartTitle-block"></div>
                  <div v-text="$t('systemQuality.versionWeekCount')"></div>
                </div>
                <chart-base 
                v-if="showVer"
                ref="weekVer" 
                chart-id="weekVer" 
                :chart-data="weekVerData" 
                :chart-style="barStyleB"
                type="BAR">
                </chart-base>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>  
  </div>
</template>
<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/logic/dictionaryBiz'
  import systemQualityBiz from '@/logic/systemDiagram/systemWorkingQualityBiz'
  import describeBlock from '../component/alarmQuery/describeBlock'
  import TimeFormat from '@/utils/timeFormat.js'
  import chartBase from '@/components/chart/chart-base.vue'
  import { extend } from '@/utils/tool'

  const AREA_STYLE = {
    grid: {
      left: '7%',
      right: '7%',
      bottom: '15%',
      containLabel: true
    },
    legend: {
      data: [],
      top: 8
    },
    tooltip: {
      trigger: 'axis'
    }
  }
  const PIE_STYLE = {
    grid: {
      left: '7%',
      right: '7%',
      bottom: '15%',
      containLabel: true
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b} : {c} ({d}%)'
    },
    legend: {
      orient: 'horizontal',
      bottom: 15,
      data: []
    },
    series: [
      {
        name: '',
        type: 'pie',
        radius: ['50%', '70%'],
        center: ['50%', '38%'],
        avoidLabelOverlap: false,
        data: [],
        label: {
          normal: {
            show: false,
            position: 'center'
          },
          emphasis: {
            show: true,
            textStyle: {
              fontSize: '18',
              fontWeight: 'bold'
            }
          }
        },
        lableLine: {
          normal: {
            show: false
          }
        }
      }
    ]
  }
  const BAR_STYLE = {
    color: ['#52B947', '#40C3B3'],
    backgroundColor: '#FFFFFF',
    grid: {
      left: '7%',
      right: '7%',
      bottom: '12%',
      containLabel: true
    },
    legend: {
      data: []
    },
    xAxis: {
      boundaryGap: ['20%', '20%'],
      axisTick: {
        alignWithLabel: true
      }
    },
    series: {
      barWidth: '60%'
    }
  }
  export default {
    mixins: [rac],
    data () {
      const that = this
      return {
        form: {
          startTime: '',
          endTime: ''
        },
        showVer: false,
        showAcd: true,
        accList: [],
        verList: [],
        accTrendData: {},
        verTrendData: {},
        areaStyleA: {},
        areaStyleB: {},
        pieStyleA: {},
        pieStyleB: {},
        pieStyleC: {},
        pieStyleD: {},
        barStyleA: {},
        barStyleB: {},
        // verTrendTime: [],
        // verTrendLegend: [],
        weekAccLegend: [],
        weekAccData: {},
        weekAccX: [],
        weekVerLegend: [],
        weekVerX: [],
        weekVerData: [],
        moduleChartData: {},
        reasonChartData: {},
        regularChartData: {},
        patchChartData: {},
        tabName: that.$t('systemQuality.accidentCount')
      }
    },
    methods: {
      e_init () {
        const start = new Date()
        start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), 1))
        this.form.startTime = start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), 1))
        this.areaStyleA = extend(true, {}, AREA_STYLE)
        this.areaStyleB = extend(true, {}, AREA_STYLE)
        this.pieStyleA = extend(true, {}, PIE_STYLE)
        this.pieStyleB = extend(true, {}, PIE_STYLE)
        this.pieStyleC = extend(true, {}, PIE_STYLE)
        this.pieStyleD = extend(true, {}, PIE_STYLE)
        this.barStyleA = extend(true, {}, BAR_STYLE)
        this.barStyleB = extend(true, {}, BAR_STYLE)
        this.search()
      },
      search () {
        this.form.endTime = this.form.endTime === '' ? new Date().getTime() : this.form.endTime
        if (this.form.startTime >= this.form.endTime) {
          this.$message({
            message: this.$t('systemQuality.timeAlert'),
            type: 'warning'
          })
          return
        }
        this.getWeekAccCount(this.form)
        this.getWeekVerCount(this.form)
        // 系统事故
        systemQualityBiz.systemAccident(this.form).then((data) => {
          this.accList = [{ num: data.accidentCount, title: this.$t('systemQuality.accident') },
            { num: TimeFormat.getAutoFormatTime(data.totalRecoveryTime), title: this.$t('systemQuality.totalRecoveryTime') },
            { num: TimeFormat.getAutoFormatTime(data.avgRecoveryTime), title: this.$t('systemQuality.avgRecoveryTime') },
            { num: TimeFormat.getAutoFormatTime(data.maxRecoveryTime), title: this.$t('systemQuality.maxRecoveryTime') }]
          let reason = {}
          dic.searchDictionaryByCode('accidentType').then((d) => {
            let chartData = []
            data.accidentTrend.map((item) => {
              chartData.push({count: item.count, time: item.time})
            })
            // 饼图
            let moduleData = [{}]
            let moduleLegend = []
            let reasonData = [{}]
            let reasonLegend = []
            for (const i in data.groupCount) {
              moduleLegend.push(i)
              moduleData[0][i] = data.groupCount[i]
            }
            reason = d
            for (let i in data.reasonCount) {
              const a = i
              for (const j in reason) {
                if (i === j) {
                  i = reason[j]
                  break
                }
              }
              reasonLegend.push(i)
              reasonData[0][i] = data.reasonCount[a]
            }
            this.pieStyleA.legend = {
              data: moduleLegend,
              bottom: '2%'
            }
            this.pieStyleB.legend = {
              data: reasonLegend,
              bottom: '2%'
            }
            this.$nextTick(() => {
              this.accTrendData = {
                rows: chartData,
                columns: ['time', 'count'],
                colors: ['#F27373'],
                formatMap: {
                  time: 'TIME'
                },
                labelMap: {
                  count: this.$t('systemQuality.accident')
                }
              }
              this.moduleChartData = {
                rows: Object.keys(moduleData[0]).length !== 0 ? moduleData : [],
                columns: ['name', ...moduleLegend],
                name: this.$t('systemQuality.module')
              }

              this.reasonChartData = {
                rows: Object.keys(reasonData[0]).length !== 0 ? reasonData : [],
                columns: ['name', ...reasonLegend],
                name: this.$t('systemQuality.reason')
              }
            })
            // 版本发布
            systemQualityBiz.systemVersion(this.form).then((data) => {
              let vData = []
              data.releaseTrend.map((item) => {
                vData.push({patchCount: item.patchCount, regularCount: item.regularCount, time: item.time})
              })
              this.areaStyleB.legend = {
                type: 'scroll',
                width: '70%',
                top: '4%',
                data: [this.$t('systemQuality.patchVersionCount'), this.$t('systemQuality.regularVersionCount')]
              }
              this.verList = [{ num: data.releaseCountAll, title: this.$t('systemQuality.version') },
                { num: data.regularVersionCount, title: this.$t('systemQuality.regularVersionCount') },
                { num: data.patchVersionCount, title: this.$t('systemQuality.patchVersionCount') }]
              let regularData = [{}]
              let regularLegend = []
              let patchData = [{}]
              let patchLegend = []
              for (const i in data.regularVersionGroup) {
                regularLegend.push(i)
                regularData[0][i] = data.regularVersionGroup[i]
              }
              for (const i in data.patchVersionGroup) {
                patchLegend.push(i)
                patchData[0][i] = data.patchVersionGroup[i]
              }
              this.pieStyleC.legend = {
                data: regularLegend,
                bottom: '2%'
              }
              this.pieStyleD.legend = {
                data: patchLegend,
                bottom: '2%'
              }
              this.$nextTick(() => {
                this.verTrendData = {
                  rows: vData,
                  columns: ['time', 'patchCount', 'regularCount'],
                  formatMap: {
                    time: 'TIME'
                  },
                  colors: ['#F27373', '#FFB517'],
                  labelMap: {
                    patchCount: this.$t('systemQuality.patchVersionCount'),
                    regularCount: this.$t('systemQuality.regularVersionCount')
                  }
                }
                this.regularChartData = {
                  rows: Object.keys(regularData[0]).length !== 0 ? regularData : [],
                  columns: ['name', ...regularLegend],
                  name: this.$t('systemQuality.module')
                }

                this.patchChartData = {
                  rows: Object.keys(patchData[0]).length !== 0 ? patchData : [],
                  columns: ['name', ...patchLegend],
                  name: this.$t('systemQuality.module')
                }
              })
            })
          })
        })
      },
      getWeekAccCount (searchInfo) {
        systemQualityBiz.accidentWeekStatistics(searchInfo).then((data) => {
          if (this.weekAccLegend.length === 0) {
            this.weekAccLegend.push(this.$t('chart.problemCount'), this.$t('chart.seriousCount'))
          }
          let weekData = []
          this.weekAccX = data
          this.weekAccX.map((item) => {
            let obj = {}
            Object.keys(item).forEach((d) => {
              if (d !== 'week' && d !== 'year') {
                obj[d] = item[d]
              }
            })
            obj.time = `${item['year']}-第${item['week']}周`
            weekData.push(obj)
          })
          this.barStyleA.legend = {
            data: this.weekAccLegend,
            top: '2%'
          }
          this.$nextTick(() => {
            this.weekAccData = {
              rows: weekData,
              columns: ['time', 'problemCount', 'seriousCount'],
              labelMap: {
                problemCount: this.$t('chart.problemCount'),
                seriousCount: this.$t('chart.seriousCount')
              }
            }
          })
        })
      },
      getWeekVerCount (searchInfo) {
        systemQualityBiz.versionWeekStatistics(searchInfo).then((data) => {
          if (this.weekVerLegend.length === 0) {
            this.weekVerLegend.push(this.$t('chart.releaseCount'), this.$t('chart.patchCount'))
          }
          this.weekVerX = data
          let weekData = []
          this.weekVerX.map((item) => {
            let obj = {}
            Object.keys(item).forEach((d) => {
              if (d !== 'week' && d !== 'year') {
                obj[d] = item[d]
              }
            })
            obj.time = `${item['year']}-第${item['week']}周`
            weekData.push(obj)
          })
          this.barStyleB.legend = {
            data: this.weekVerLegend,
            top: '2%'
          }
          this.$nextTick(() => {
            this.weekVerData = {
              rows: weekData,
              columns: ['time', 'releaseCount', 'patchCount'],
              labelMap: {
                releaseCount: this.$t('chart.releaseCount'),
                patchCount: this.$t('chart.patchCount')
              }
            }
          })
        })
      },
      tabClick (event) {
        if (event.index === '1') {
          this.showVer = true
          this.showAcd = false
        } else {
          this.showAcd = true
          this.showVer = false
        }
      }
    },
    components: {
      describeBlock,
      chartBase
    },
    mounted () {
      this.e_init()
    }
  }
</script>

<style scoped>
  .systemQuality__chart{
    height: 350px;
    margin-top: 50px; 
    margin-bottom: 10px;
  }
  .systemQuality__chartTitle div{
    margin-bottom: 10px; 
    line-height: 20px;
    font-size: 14px;
    display: inline-block;
    vertical-align: middle;
  }
  .systemQuality__chartTitle-block {
    background: #000;
    height: 20px;
    width: 20px;   
  }
  .systemQuality__chart-pie {
    display: flex;
    justify-content: space-around;
  }
  .systemQuality__chart-pieBlock {
    width: 460px;
    margin: 0;
  }
</style>